export default __webpack_public_path__ + "static/media/green_tick_dark.38118a7c.svg";